<svelte:options accessors={true} />

<script>
    import { onMount } from 'svelte';
    import Row from './Row.svelte'
    export let type = 0
    export let status = -1
    export let mail = ''
    export let verifyCode = ''
    export let busy = false
    export let error = undefined
    let updateTimer = undefined

    onMount(async () => {
        busy = true
        responseAuth(await app.request({method: 'auth'}))
        busy = false
    })

    function responseAuth(resp) {
        if (resp.status === 1 && typeof resp.account === 'object') {
            clearTimeout(updateTimer)
            app.account = resp.account
            status = 2
            return true
        }
        verifyCode = resp.verifyCode ?? ''
        if (status < 0) status = 0
    }

    async function processTelegram() {
        clearTimeout(updateTimer)
        updateTimer = setTimeout(async() => {
            if (!responseAuth(await app.request({method: 'auth'}))) {
                processTelegram()
            }
        }, 3000)
    }

    async function processEmail() {
        busy = true
        error = undefined
        if (status === 0) {
            mail = mail.toLowerCase().trim()
            if (mail.length > 3 && mail.indexOf('@') > -1) {

                let captcha = await new Promise((resolve,reject) => {
                    grecaptcha.ready(function() {
                        grecaptcha.execute('6LfiW9UeAAAAADTPEY6MYa4pM24nER6j3jLdEjB4', {action: 'submit'}).then(function(token) {
                            resolve(token)
                        });
                    });  
                })

                if (captcha && captcha.length > 0) {
                    let resp = await app.request({method: 'authMail', mail: mail, captcha: captcha })
                    if (resp.status === 1) {
                        status = 1
                    }
                } else error = 'Ты робот что-ли? 🤖🤔'
            } else error = 'Какое-то странное мыло ты вводишь ... Хм 🧐'
        } else {
            let resp = await app.request({method: 'authVerifyCode', mail: mail, code: verifyCode })
            if (!responseAuth(resp)) {
                verifyCode = ''
                error = 'Я тебе выслал код на Email, что ты вводишь? ✋'
            } 
        }
        busy = false
    }
</script>

{#if type==1}
<Row title="Вход через Почту" info="Для продолжения надо выполнить вход, чтобы понять что по чём 🤷‍♂️" busy={busy}>
    {#if error}
        <div class="alert alert-danger" role="alert">
            {error}
        </div>
    {/if}
    {#if status > -1}
        <script src="https://www.google.com/recaptcha/api.js?render=6LfiW9UeAAAAADTPEY6MYa4pM24nER6j3jLdEjB4"></script>

        <input type="text" class="form-control" id="mail" placeholder="email@mail.ru" bind:value={mail} disabled={status>0} />
        {#if status == 1}
            <input type="text" class="form-control" id="verify-code" placeholder="тут вводи код с Email" bind:value={verifyCode} />
        {/if}
    
        <button on:click={processEmail} type="button" class="btn btn-secondary mr-2">Отправить код на почту</button>            
    {/if}
</Row>
{:else if type==2}
    <Row title="Вход через Telegram" info="После открытия чата в Telegram внизу нажми 'Начать' или 'Start'" busy={busy}>
        <a target="_blank" on:click={processTelegram} href="https://t.me/vmshvbot?start=LOGIN{app.sessionId()}" role="button" class="btn btn-secondary mr-2">Продолжить</a>
    </Row>
{:else}
    <!-- 
        <Row title="Вход" info="Нужно выполнить вход, есть два варианта:" busy={busy}>
            <button on:click={() => {type=2}} type="button" class="btn btn-primary mr-2">Вход через Telegram</button>
            <button on:click={() => {type=1}} type="button" class="btn btn-secondary mr-2">Вход через Почту</button> 
        </Row>
    -->
    Error
{/if}
